import React, { useState, useEffect, useRef } from 'react';
import '../../../../pages/admin/admin_assets/css/Surveys.css';
import '../../../../pages/admin/admin_assets/css/responsive.css';
// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import enter_Arrow from '../../../../pages/admin/admin_assets/img/presskey.svg';
import preview_img from '../../../../pages/admin/admin_assets/img/preview.svg';
import share_img from '../../../../pages/admin/admin_assets/img/share.svg';
import add_img from '../../../../pages/admin/admin_assets/img/plus.svg';
import default_logo from '../../../../pages/admin/admin_assets/img/default_logo.jpg';
import { SmileOutlined } from '@ant-design/icons';
import { Button, Form, notification } from 'antd';
import { Breadcrumb } from 'antd';

import { useLocation } from 'react-router-dom';
import InvestorResult from './InvestorResult';

const InvestorForm = (props) => {

    const [currentStep, setCurrentStep] = useState(0);
    const [showError, setShowError] = useState('');
    const [showStart, setShowStart] = useState(true);
    const [successMsg, setSuccessMsg] = useState(false);

    const [showOverlay, setOverlay] = useState(false)
    const [closeOverlay, setCloseOverlay] = useState()

  const [formData, setFormData] = useState({
     
    experienceRating: [],
    valuableCollaborationAspects: [],
    communicationOfMissionAndValues: [],
    collaborationImprovement: [],
    newMarketsOrSectors: [],
    collaborationChallenges: [],
    supportAndResourcesSatisfaction: [],
    communicationTransparency: [],
    collaborationEnhancementAreas: [],
    strategicAlignment: [],
    conflictManagementFeedback: [],
    serviceReliability: [],
    additionalResources: []
      
  });

  const questions = [
    {
        id: 1,
        questionText: "How aligned do you feel our business strategy is with your investment goals?",
        answerKey: 'strategicAlignment',
        options: ['A Strongly Aligned', 'B Moderately Aligned', 'C Neutral', 'D Not Aligned'],
        inputType: 'button'
    },
    {
        id: 2,
        questionText: "What aspects of our business performance do you find most encouraging?",
        answerKey: 'valuableCollaborationAspects',
        options: ['A Revenue Growth', 'B Innovation', 'C Market Expansion', 'D Leadership'],
        inputType: 'button'
    },
    {
        id: 3,
        questionText: "How transparent do you find our financial reporting and communication?",
        answerKey: 'communicationTransparency',
        options: ['A Very Transparent', 'B Moderately Transparent', 'C Neutral', 'D Not Transparent'],
        inputType: 'button'
    },
    {
        id: 4,
        questionText: "How would you rate the quality of information shared in our investor updates and reports?",
        answerKey: 'communicationOfMissionAndValues',
        options: ['A Excellent', 'B Good', 'C Average', 'D Poor'],
        inputType: 'button'
    },
    {
        id: 5,
        questionText: "How do you perceive our brand’s long-term growth potential?",
        answerKey: 'newMarketsOrSectors',
        options: ['A High', 'B Moderate', 'C Neutral', 'D Low'],
        inputType: 'button'
    },
    {
        id: 6,
        questionText: "What areas of our business would you like to see improved or developed further?",
        answerKey: 'collaborationImprovement',
        options: ['A Market Diversification', 'B Product Innovation', 'C Sustainability', 'D Operational Efficiency'],
        inputType: 'button'
    },
    {
        id: 7,
        questionText: "How satisfied are you with the return on your investment to date?",
        answerKey: 'experienceRating',
        options: ['A Very Satisfied', 'B Satisfied', 'C Neutral', 'D Dissatisfied'],
        inputType: 'button'
    },
    {
        id: 8,
        questionText: "How do you assess the risk factors associated with our brand and market position?",
        answerKey: 'conflictManagementFeedback',
        options: ['A Low Risk', 'B Moderate Risk', 'C High Risk', 'D Very High Risk'],
        inputType: 'button'
    },
    {
        id: 9,
        questionText: "How responsive are we to your queries or concerns regarding your investment?",
        answerKey: 'supportAndResourcesSatisfaction',
        options: ['A Very Responsive', 'B Moderately Responsive', 'C Neutral', 'D Unresponsive'],
        inputType: 'button'
    },
    {
        id: 10,
        questionText: "How would you rate our market positioning relative to competitors?",
        answerKey: 'serviceReliability',
        options: ['A Excellent', 'B Good', 'C Average', 'D Poor'],
        inputType: 'button'
    },
    {
        id: 11,
        questionText: "What additional information or resources would enhance your understanding of our business?",
        answerKey: 'additionalResources',
        options: ['A Market Analysis', 'B Competitive Insights', 'C Product Roadmap', 'D Financial Projections'],
        inputType: 'button'
    },
    {
        id: 12,
        questionText: "What is your level of confidence in our leadership team’s ability to deliver on strategic objectives?",
        answerKey: 'collaborationEnhancementAreas',
        options: ['A Very Confident', 'B Confident', 'C Neutral', 'D Not Confident'],
        inputType: 'button'
    },
    {
        id: 13,
        questionText: "How would you rate our overall investor relations approach?",
        answerKey: 'strategicAlignment',
        options: ['A Excellent', 'B Good', 'C Average', 'D Poor'],
        inputType: 'button'
    },
    {
        id: 14,
        questionText: "What do you see as the biggest opportunity for growth in our sector?",
        answerKey: 'strategicAlignment',
        options: ['A New Markets', 'B Technology Adoption', 'C Customer Acquisition', 'D Cost Optimization'],
        inputType: 'button'
    }
      
  ];
     
  useEffect(() => {
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            if (showStart) {
                setShowStart(false);
            } else {
                nextStep(formData[questions[currentStep].answerKey]);
            }
        }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
}, [showStart, currentStep, formData, questions]); 


const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
    if (showError && value.trim() !== "") {
        setShowError('');
    }
};

const handleOptionClick = (answerKey, option) => {
    setFormData(prevState => ({
        ...prevState,
        [answerKey]: prevState[answerKey]
            ? prevState[answerKey].includes(option)
                ? prevState[answerKey].filter(item => item !== option)
                : [...prevState[answerKey], option]
            : [option] 
    }));
};

const nextStep = (currentInputValue) => {
    if ((typeof currentInputValue === 'string' && currentInputValue.trim() === "") ||
        (Array.isArray(currentInputValue) && currentInputValue.length === 0)) {
        setShowError('Required Field');
    } else {
        setShowError('');
        if (currentStep < questions.length - 1) {
            setCurrentStep(currentStep + 1);
        } else {
            handleSubmit();
        }
    };
}

const handleSubmit = () => {
    console.log(formData);
    setSuccessMsg('Form submitted. Check the console for data.');
};

// show copy link 
const [showCopyLink, setShowCopyLink] = useState(false)

const copyLink = ()=>{
    setShowCopyLink(true)
}



    // file file and drag 

    const [selectedImage, setSelectedImage] = useState(false);

    const getFile = ((event)=>{
        console.log(event);
            setSelectedImage(URL.createObjectURL(event.target.files[0]))
    });

    const handleDragOver = (event) => {
        event.preventDefault(); // Prevent default behavior (prevent file from being opened)
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0]; // Access files from the dataTransfer object
        if (file) {
            setSelectedImage(URL.createObjectURL(file));
        }
    };
    
    // file upload modal
    const [modalShow, setModalShow] = React.useState(false);

    function MyVerticallyCenteredModal(props) {
        return (
          <Modal
            {...props}
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton className='border-0'>
         
            </Modal.Header>
            <Modal.Body>
            <div className='position-relative'>
                    <input 
                        type="file" 
                        onChange={getFile} 
                        onDragOver={handleDragOver} 
                        onDrop={handleDrop} 
                        className='upload_logo_modal'
                        style={{ width: '100%'}} // Style as needed
                    />
                    <div className='upload_txt'>
                        <p className='mb-0'>Upload or drop an image right here</p>
                        <p className="file-types mb-0">JPG, PNG, or GIF. Up to 4MB.</p>
                        
                    </div>
                    {selectedImage && (
                        <div className='preview_img'>
                            <img src={selectedImage} alt="Selected" style={{ width: '100%', marginTop: '10px' }} />
                        </div>
                    )}

                    <div className='update text-center'>
                        <button onClick={updateHandle}>Update</button>
                    </div>
                </div>
            </Modal.Body>
          </Modal>
        );
      }

                      const [surveyTab, setSurveyTab] = useState(true)
                     const [resultTab, setResultTab] = useState(false)
                     
                     const [activeTab, setActiveTab] = useState('create')
                     const createHandle = ()=>{
                        setSurveyTab(true)
                        setResultTab(false)
                        setActiveTab('create')
                     }
            
                     const resultHandle = ()=>{
                       setResultTab(true)
                       setSurveyTab(false)
                       setActiveTab('result')
            
                   }
   
                //      const createHandle = ()=>{
                //         setSurveyTab(true)
                //         setResultTab(false)
                //         setActiveTab('create')
                //      }
   
                //      const resultHandle = ()=>{
                //        setResultTab(true)
                //        setSurveyTab(false)
                //        setActiveTab('result')
   
                //    }
                   const handleTabChange = (tab) => {
                       setActiveTab(tab);  // Set the active tab state
                   };
   
    //   hide copy link when preview icon clicked
    const [showPreview, setShowPreview] = useState()

    const hideCopyLink = ()=>{
        setShowPreview(false)
    }

          // adding overlay to the page
          const addBg = ()=>{
            setOverlay(true)
            setShowCopyLink(false)
            setFullForm('full_form')

        }

        const closePopOverlay = () =>{
            setOverlay(false)
            setFullForm(false)
        }

        // add new class for form
        const [fullForm, setFullForm] = useState()

        // Toast message to link copied
        const [api, contextHolder] = notification.useNotification();
        
        const openNotification = () => {
            api.open({
                message: 'Your form link has been copied',
            //   description:
            //     'Your form link has been copied',
              icon: (
                <SmileOutlined
                  style={{
                    color: '#108ee9',
                  }}
                />
              ),
            });
          };

        // copy link clipboard text

        const [copyFormLink, setCopyFormLink] = useState('https://form.typeform.com/to/orl4Qfv7')

        const clickText = async ()=>
        {
                    try{
                            await window.navigator.clipboard.writeText(copyFormLink)
                            openNotification()
                    }

                    catch(error){
                        console.error('Unable to copy the clipboard', error)
                    }
        }

        const [successMessage, setSuccessMessage] = useState(false)

        const updateHandle=()=>{
            setSuccessMessage(true)
        }

        const [customerForm,setCustomerForm] = useState(false)
        const [employeeForm,setEmployeeForm] = useState(false)
        const [partnerForm,setPartnerForm] = useState(false)
        const [investorForm,setInvestorForm] = useState(false)

        let location = useLocation();

        useEffect(()=>{

            if(location.pathname==="/admin/customer-form"){
                    // console.log("Yes it is customer detail");
                    // setCustomerForm(<CustomerForm/>)
                    setCustomerForm(true)

            }
            else if(location.pathname==="/admin/employee-form"){
                // console.log("Yes it is employee detail");
                // setEmployeeForm(<EmployeeForm/>)
                setEmployeeForm(true)
                setCustomerForm(false)

            }
            else if(location.pathname==="/admin/partner-form"){
                // console.log("Yes it is partner detail");
                // setPartnerForm(<PartnerForm/>)
                setPartnerForm(true)

            }
            else if(location.pathname==="/admin/investor-form"){
                // console.log("Yes it is investor detail");
                // setInvestorForm(<InvestorForm/>)
                setInvestorForm(true)
                setCustomerForm(false)

            }
            
        },[])

return (
<div className='container-fluid'>

{ <Breadcrumb
            items={[
            {
                title: 'Surveys ',
                href: '#'
            },
            
            {
                title: 'Investor',
            },
            ]}
        />}

        <div className='tabs_border survey_tabs'>
                <button onClick={createHandle} className={activeTab==='create' ? 'tab_active' :''}>
                    <p>Create</p>
                 </button>
                <button onClick={resultHandle} className={activeTab==='result' ? 'tab_active' :''}>
                    <p>Result</p>
                </button>
        </div>

     {contextHolder}


            {
                surveyTab ? (
<div className='form'>
    {
            showOverlay &&
                    <div className='overlay'>
                        <div className='' onClick={closePopOverlay}>
                            <p >
                            <img src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path fill='%23ffffff' d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z'/></svg>" alt="close"  style={{width:"19px"}}/>
                            </p>
                            </div>
                    </div>
    }
    {
        showCopyLink ? ( 
        <div className='copy_link_wrapper'>
            <div className='copy_link'>
                    <button onClick={clickText}><i class="fa fa-solid fa-link"></i> Copy</button>
                    <input type="text" value={copyFormLink}  onChange={(e)=>setCopyFormLink(e.target.value)}
                    />
            </div>    
        </div>

        ) : ("")
    }
    <div className={`form_wrapper ${fullForm ? "form_style" : ""}`}>
        <div className='row'>
            {
                selectedImage ? (
                <div className='log_upload'>
                    <img src={selectedImage} alt="" className='d_logo' />
                </div>
                ):
                (
                   
                 <div className='log_upload'> 
                 <img src={default_logo} alt="" className='d_logo' />
                 </div>
                ) 
                
            }
            
            <div className='parent'>
              
            <div className="form_sec">
            {
             showOverlay &&
                <div className='form_style_overlay'>
                    <div className='text-center' onClick={closePopOverlay}>
                        <p > <i class="fa-solid fa-xmark text-black"></i></p>
                        </div>
                </div>
          }

                {showStart ? 
                (
                    <div className='start'>
                        <h3>We're Here to Help! [InvestorForm]</h3>
                        <p>Have questions or need assistance? Get in touch with us today.</p>
                        <div className='start_btn'>
                            <button onClick={() => setShowStart(false)}>Start</button>
                            <p>Press Enter <img src={enter_Arrow} alt="Enter Arrow" /></p>
                        </div>
                    </div>
                ) 
                : successMsg ?
                (
                    <div className='success-message'>
                        <h4>
                        🎉 Thank You for Prebooking!
                        </h4>
                <p>Our team will reach out to you shortly with further details. For questions, reach out at <a href='mailto:support@brewyourbrand.in'>support@brewyourbrand.in</a>  or call <a href="tel:+918150002200">+91 8150 00 22 00</a></p>
                    </div>
                )
                :
                ((

                    <div className='question_form'>
                        <form onSubmit={handleSubmit}>
                            {questions.map((question, index) => (
                                currentStep === index && (
                                    <div key={question.id}>
                                        <label>{question.id}. {question.questionText}</label>
                                        {question.inputType === 'button' ? 
                                            question.options.map(option => (
                                                <div className='check_form'>
                                                <div key={option}
                                                     className={`button-option ${formData[question.answerKey].includes(option) ? 'active' : ''}`}
                                                     onClick={() => handleOptionClick(question.answerKey, option)}>
                                                    {/* <span className="button-label">{option.charAt(0)}</span> */}
                                                     {option.slice(1)}
                                                </div>
                                                </div>
                                            )) : (
                                                <div className='text_form'>
                                                <input
                                                    type={question.inputType}
                                                    value={formData[question.answerKey]}
                                                    onChange={handleInputChange}
                                                    name={question.answerKey}
                                                />
                                                </div>
                                            )}
                                        <div className='next_prev'>
                                            {index > 0 && (
                                                <button type="button" onClick={() => setCurrentStep(currentStep - 1)}>Previous</button>
                                            )}
                                            {index < questions.length - 1 ? (
                                                <>
                                                <button type="button" onClick={() => nextStep(formData[questions[currentStep].answerKey])}>Next</button>
                                                </>
                                            ) : (
                                                <button type="submit">Submit</button>
                                            )}
                                        </div>
                                        {showError && <p className="error">{showError}</p>}
                                    </div>
                                )
                            ))}
                        </form>
                    </div>
                )
                )
                }
            </div>
            <div className='edit_prev'>
                <div className='right_wrapper'>
                        <div className='previous' onClick={addBg}>
                            <p>Preview</p>
                             <img src={preview_img} alt="" />
                        </div>
                        <hr />
                        <div className='share' onClick={copyLink}>
                            <p>Share</p>
                            <img src={share_img} alt="" />

                        </div>
                </div>

                <div className='edit_wrapper'>
                    <div className='edit_sec'>
                        <h5 className='mb-0'>Edit Preferences</h5>
                     </div>

                    <div className='brand_wrapper' onClick={() => setModalShow(true)}>
                        <p>Brand Logo</p>
                        <img src={add_img} alt="" />
                    </div>
                    {
                        successMessage && 
                        <div className="upload_msg">
                        <p>updated successfully</p>
                            </div>
                    }
                         
                </div>
            </div>
            </div>
        </div>
    </div>
    </div>
                ) :

                (
                    <div className=''>
                        <InvestorResult/>
                    </div> 
                )
            }

    

         
        <MyVerticallyCenteredModal
    show={modalShow}
    onHide={() => setModalShow(false)}
  />

</div>
)
}

export default InvestorForm